import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

const Encrypt: React.FC = () => {
  // Set page title automatically based on route
  usePageTitle();
  
  return (
    <div className="text-center py-12">
      <h1 className="text-2xl font-bold text-gray-900">Encrypt Page</h1>
      <p className="text-gray-600 mt-2">Coming Soon</p>
    </div>
  );
};

export default Encrypt;
